import { sendGTMEvent } from '~/features/shared/gtmEvent/sendGTMEvent'
import { deviceAdapter } from '~/lib/deviceAdapter'

export const sendGtmEvAppRedirectHalfModalButton = () => {
  const baseEventData = {
    event: 'content_AppDownload',
    pageGroup: 'userdetail',
    click_content_type: 'modal',
  } as const
  sendGTMEvent(
    deviceAdapter(
      {
        ios: { ...baseEventData, appstore: 'App_iOS' },
        android: { ...baseEventData, appstore: 'App_And' },
      },
      {}
    )
  )
}

export const sendGtmEvShowHalfModal = () => {
  const baseEventData = {
    event: 'imp_content_AppDownload',
    pageGroup: 'userdetail',
    click_content_type: 'modal',
  } as const
  sendGTMEvent(
    deviceAdapter(
      {
        ios: { ...baseEventData, appstore: 'App_iOS' },
        android: { ...baseEventData, appstore: 'App_And' },
      },
      {}
    )
  )
}
